/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import {
  INTERVENTION_STATUS_ENDED,
  INTERVENTION_STATUS_ONGOING,
  INTERVENTION_STATUS_TO_COME_UP,
  INTERVENTION_STATUS_UNKNOWN
} from '../../enums/InterventionStatusCodes.mjs'
import Filter, { FilterableProps } from '../Filter'
import { Checkbox, Radio } from '@mantine/core'
import useArrayFilter from '../../../../client/js/hooks/useArrayFilter'

function InterventionStatusFilter (props: FilterableProps<string[]>) {
  const { onChange, value } = props
  const intl = useIntl()
  const [array, handleChange] = useArrayFilter(value, onChange)
  return (
    <Filter>
      <Radio
        checked={array.length === 0}
        label={intl.formatMessage({
          id: 'all',
          defaultMessage: 'Tout'
        })}
        name="status"
        onChange={(event) => {
          if (event.target.checked) {
            onChange(event.target.name, undefined)
          }
        }}
        value=""
      />
      <Checkbox
        checked={array.includes(INTERVENTION_STATUS_UNKNOWN)}
        label={intl.formatMessage({
          id: 'unknown',
          defaultMessage: 'Inconnu'
        })}
        name="status"
        onChange={handleChange}
        value={INTERVENTION_STATUS_UNKNOWN}
      />
      <Checkbox
        checked={array.includes(INTERVENTION_STATUS_TO_COME_UP)}
        label={intl.formatMessage({
          id: 'to_come_up',
          defaultMessage: 'À venir'
        })}
        name="status"
        onChange={handleChange}
        value={INTERVENTION_STATUS_TO_COME_UP}
      />
      <Checkbox
        checked={array.includes(INTERVENTION_STATUS_ONGOING)}
        label={intl.formatMessage({
          id: 'ongoing',
          defaultMessage: 'En cours'
        })}
        name="status"
        onChange={handleChange}
        value={INTERVENTION_STATUS_ONGOING}
      />
      <Checkbox
        checked={array.includes(INTERVENTION_STATUS_ENDED)}
        label={intl.formatMessage({
          id: 'finished',
          defaultMessage: 'Terminé'
        })}
        name="status"
        onChange={handleChange}
        value={INTERVENTION_STATUS_ENDED}
      />
    </Filter>
  )
}

export default InterventionStatusFilter
